<template>
  <div class="mt-2 mb-3 ml-3 mr-3">
    <div class="main-title mb-4">Application Information</div>

    <div v-if="loading" class="text-center pa-4">
      <v-progress-circular
        indeterminate
        color="success"
        size="40"
      ></v-progress-circular>
      <div class="mt-2 text--secondary">Loading application info...</div>
    </div>

    <div v-else>
      <!-- Father Information -->
      <div class="mb-4">
        <div class="section-header">טאטע</div>

        <div
          v-if="
            !applicationInfo.fatherCity &&
              !applicationInfo.fatherSchool &&
              !applicationInfo.fatherYeshivahKetana &&
              !applicationInfo.fatherYeshivahGedolah
          "
          class="no-info"
        >
          No info filled...
        </div>

        <div class="detail-row" v-if="applicationInfo.fatherCity">
          <span class="label">Father City:</span>
          <span>{{ applicationInfo.fatherCity }}</span>
        </div>

        <div class="detail-row" v-if="applicationInfo.fatherSchool">
          <span class="label">?טאטע איז א תלמיד פון חדר:</span>
          <span>{{ applicationInfo.fatherSchool }}</span>
        </div>

        <div class="detail-row" v-if="applicationInfo.fatherYeshivahKetana">
          <span class="label">?טאטע איז א תלמיד פון ישיבה קטנה:</span>
          <span>{{ applicationInfo.fatherYeshivahKetana }}</span>
        </div>

        <div class="detail-row" v-if="applicationInfo.fatherYeshivahGedolah">
          <span class="label">?טאטע איז א תלמיד פון ישיבה גדולה:</span>
          <span>{{ applicationInfo.fatherYeshivahGedolah }}</span>
        </div>
      </div>

      <!-- Mother Information -->
      <div class="mb-4">
        <div class="section-header">מאמע</div>

        <div
          v-if="
            !applicationInfo.motherSchool &&
              !applicationInfo.motherGraduatedYear
          "
          class="no-info"
        >
          No info filled...
        </div>

        <div class="detail-row" v-if="applicationInfo.motherSchool">
          <span class="label">?מאמע איז תלמידה פון:</span>
          <span>{{ applicationInfo.motherSchool }}</span>
        </div>

        <div class="detail-row" v-if="applicationInfo.motherGraduatedYear">
          <span class="label">?וועלכע יאר גענדיגט די 11 טע קלאס:</span>
          <span>{{ applicationInfo.motherGraduatedYear }}</span>
        </div>
      </div>

      <!-- Landlord -->
      <div class="mb-4">
        <div class="section-header">Landlord</div>

        <div
          v-if="!applicationInfo.landlord && !applicationInfo.landlordPhone"
          class="no-info"
        >
          No info filled...
        </div>

        <div class="detail-row" v-if="applicationInfo.landlord">
          <span class="label">Landlord:</span>
          <span>{{ applicationInfo.landlord }}</span>
        </div>

        <div class="detail-row" v-if="applicationInfo.landlordPhone">
          <span class="label">Landlord Phone:</span>
          <span>{{ applicationInfo.landlordPhone }}</span>
        </div>
      </div>

      <!-- Emergency Contact -->
      <div class="mb-4">
        <div class="section-header">Emergency Contact</div>

        <div
          v-if="
            !applicationInfo.inCaseOfEmergencyName &&
              !applicationInfo.inCaseOfEmergencyPhone
          "
          class="no-info"
        >
          No info filled...
        </div>

        <div class="detail-row" v-if="applicationInfo.inCaseOfEmergencyName">
          <span class="label">Emergency Contact Name:</span>
          <span>{{ applicationInfo.inCaseOfEmergencyName }}</span>
        </div>

        <div class="detail-row" v-if="applicationInfo.inCaseOfEmergencyPhone">
          <span class="label">Emergency Contact Phone #:</span>
          <span>{{ applicationInfo.inCaseOfEmergencyPhone }}</span>
        </div>
      </div>

      <!-- Work Information -->
      <div class="mb-4">
        <div class="section-header">ארבעט</div>

        <div
          v-if="
            !applicationInfo.workPlaceOrBoss &&
              !applicationInfo.workBoss &&
              !applicationInfo.workType &&
              !applicationInfo.workAddress &&
              !applicationInfo.workPhone &&
              !applicationInfo.workPosition &&
              !applicationInfo.yearsInPosition &&
              !applicationInfo.wifeWorkPlaceOrBoss &&
              !applicationInfo.wifeWorkBoss &&
              !applicationInfo.wifeWorkType &&
              !applicationInfo.wifeWorkAddress &&
              !applicationInfo.wifeWorkPhone &&
              !applicationInfo.wifeWorkPosition &&
              !applicationInfo.wifeYearsInPosition
          "
          class="no-info"
        >
          No info filled...
        </div>

        <!-- Father's Work -->
        <div class="font-weight-bold mb-1 mt-2" style="font-size: 12px;">
          טאטע'ס ארבעט
        </div>

        <div class="detail-row" v-if="applicationInfo.workPlaceOrBoss">
          <span class="label">ארבעט:</span>
          <span>{{ applicationInfo.workPlaceOrBoss }}</span>
        </div>
        <div class="detail-row" v-if="applicationInfo.workBoss">
          <span class="label">נאמען פון בעה''ב:</span>
          <span>{{ applicationInfo.workBoss }}</span>
        </div>

        <div class="detail-row" v-if="applicationInfo.workType">
          <span class="label">Work Type:</span>
          <span>{{ applicationInfo.workType }}</span>
        </div>

        <div class="detail-row" v-if="applicationInfo.workAddress">
          <span class="label">Work Address:</span>
          <span>{{ applicationInfo.workAddress }}</span>
        </div>

        <div class="detail-row" v-if="applicationInfo.workPhone">
          <span class="label">Work Phone #:</span>
          <span>{{ applicationInfo.workPhone }}</span>
        </div>

        <div class="detail-row" v-if="applicationInfo.workPosition">
          <span class="label">Work Position:</span>
          <span>{{ applicationInfo.workPosition }}</span>
        </div>

        <div class="detail-row" v-if="applicationInfo.yearsInPosition">
          <span class="label">Years In Position:</span>
          <span>{{ applicationInfo.yearsInPosition }}</span>
        </div>

        <!-- Mother's Work -->
        <div class="font-weight-bold mb-1 mt-2" style="font-size: 12px;">
          מאמע'ס ארבעט
        </div>

        <div class="detail-row" v-if="applicationInfo.wifeWorkPlaceOrBoss">
          <span class="label">ארבעט:</span>
          <span>{{ applicationInfo.wifeWorkPlaceOrBoss }}</span>
        </div>
        <div class="detail-row" v-if="applicationInfo.wifeWorkBoss">
          <span class="label">נאמען פון בעה''ב:</span>
          <span>{{ applicationInfo.wifeWorkBoss }}</span>
        </div>

        <div class="detail-row" v-if="applicationInfo.wifeWorkType">
          <span class="label">Work Type:</span>
          <span>{{ applicationInfo.wifeWorkType }}</span>
        </div>

        <div class="detail-row" v-if="applicationInfo.wifeWorkAddress">
          <span class="label">Work Address:</span>
          <span>{{ applicationInfo.wifeWorkAddress }}</span>
        </div>

        <div class="detail-row" v-if="applicationInfo.wifeWorkPhone">
          <span class="label">Work Phone #:</span>
          <span>{{ applicationInfo.wifeWorkPhone }}</span>
        </div>

        <div class="detail-row" v-if="applicationInfo.wifeWorkPosition">
          <span class="label">Work Position:</span>
          <span>{{ applicationInfo.wifeWorkPosition }}</span>
        </div>

        <div class="detail-row" v-if="applicationInfo.wifeYearsInPosition">
          <span class="label">Years In Position:</span>
          <span>{{ applicationInfo.wifeYearsInPosition }}</span>
        </div>
      </div>

      <!-- ביהמ"ד -->
      <div class="mb-4">
        <div class="section-header">ביהמ"ד</div>

        <div
          v-if="
            !applicationInfo.shabbatSynagogue &&
              !applicationInfo.weekdaySynagogue &&
              !applicationInfo.dayan &&
              applicationInfo.isSatmarMember === null
          "
          class="no-info"
        >
          No info filled...
        </div>

        <div class="detail-row" v-if="applicationInfo.shabbatSynagogue">
          <span class="label">וואכן ביהמ''ד:</span>
          <span>{{ applicationInfo.shabbatSynagogue }}</span>
        </div>

        <div class="detail-row" v-if="applicationInfo.weekdaySynagogue">
          <span class="label">שבת ביהמ''ד:</span>
          <span>{{ applicationInfo.weekdaySynagogue }}</span>
        </div>

        <div class="detail-row" v-if="applicationInfo.dayan">
          <span class="label">דיין:</span>
          <span>{{ applicationInfo.dayan }}</span>
        </div>

        <div class="detail-row" v-if="applicationInfo.isSatmarMember !== null">
          <span class="label">קיט''ל מעמבער:</span>
          <span>{{ applicationInfo.isSatmarMember ? "Yes" : "No" }}</span>
        </div>
      </div>

      <!-- קינדער -->
      <div class="mb-4">
        <div class="section-header">קינדער</div>

        <div
          v-if="
            !applicationInfo.kidsAtHome &&
              applicationInfo.kidsInOtherSchool === null &&
              !applicationInfo.otherSchool &&
              !applicationInfo.playGroup
          "
          class="no-info"
        >
          No info filled...
        </div>

        <div class="detail-row" v-if="applicationInfo.kidsAtHome">
          <span class="label">?וויפיל קינדער האט איר אין שטוב:</span>
          <span>{{ applicationInfo.kidsAtHome }}</span>
        </div>

        <div
          class="detail-row"
          v-if="applicationInfo.kidsInOtherSchool !== null"
        >
          <span class="label">?האט איר קינדער אין אנדערע מוסדות:</span>
          <span>{{ applicationInfo.kidsInOtherSchool ? "Yes" : "No" }}</span>
        </div>

        <div class="detail-row" v-if="applicationInfo.otherSchool">
          <span class="label">נאמען פון מוסד:</span>
          <span>{{ applicationInfo.otherSchool }}</span>
        </div>

        <div class="detail-row" v-if="applicationInfo.playGroup">
          <span class="label">Play Group:</span>
          <span>{{ applicationInfo.playGroup }}</span>
        </div>
      </div>

      <!-- Benefits & Programs -->
      <div class="mb-4">
        <div class="section-header">Benefits & Programs</div>

        <div
          v-if="
            !applicationInfo.foodStampCase &&
              !applicationInfo.vouchers &&
              !applicationInfo.note
          "
          class="no-info"
        >
          No info filled...
        </div>

        <div class="detail-row" v-if="applicationInfo.foodStampCase">
          <span class="label">Food Stamp Case #:</span>
          <span>{{ applicationInfo.foodStampCase }}</span>
        </div>

        <div class="detail-row" v-if="applicationInfo.vouchers">
          <span class="label">Vouchers:</span>
          <span>{{ applicationInfo.vouchers }}</span>
        </div>

        <div class="detail-row" v-if="applicationInfo.note">
          <span class="label">Note:</span>
          <span style="white-space: pre-wrap;">{{ applicationInfo.note }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  props: {
    row: Object,
    columns: Array,
  },
  data() {
    return {
      applicationInfo: {},
      loading: true,
    };
  },
  async created() {
    await this.loadApplicationInfo();
  },
  methods: {
    async loadApplicationInfo() {
      this.loading = true;
      try {
        const response = await this.$http.get(
          "api/newfamilyapplications/GetApplicationByAccountID?accountid=" +
            this.row.familyID
        );
        this.applicationInfo = response || {};
      } catch (e) {
        console.error("Failed to load application info", e);
        this.applicationInfo = {};
      } finally {
        this.loading = false;
      }
    },
  },
  filters: {
    formatDate(value) {
      if (!value) return "";
      return moment(value).format("MM/DD/YYYY");
    },
  },
};
</script>

<style scoped>
.main-title {
  font-weight: 700;
  font-size: 20px;
  color: #333;
}

.section-header {
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 8px;
  padding-bottom: 4px;
  border-bottom: 2px solid #e0e0e0;
}

.detail-row {
  display: flex;
  margin-bottom: 6px;
  font-size: 13px;
  line-height: 1.5;
}

.detail-row .label {
  font-weight: 500;
  margin-right: 10px;
  min-width: 220px;
  flex-shrink: 0;
}

.no-info {
  color: #9e9e9e;
  font-size: 12px;
  font-style: italic;
  margin-bottom: 6px;
}
</style>
